export default "__VITE_ASSET__B82L$4xz__"